"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = exports.getCommonProperties = void 0;
const guards_1 = require("../guards");
/**
 * Takes two objects and returns an array of the keys that are common to both, with a type
 * limited to those keys.
 *
 * @param thing1 some object
 * @param thing2 another object
 * @returns an array of keys, type-limited to those keys
 */
const getCommonProperties = (thing1, thing2) => Object.keys(thing1).filter((key) => Object.keys(thing2).includes(key));
exports.getCommonProperties = getCommonProperties;
/**
 * recursive merge properties of inputs. values are merged if they are
 * plain objects or arrays, otherwise if the same property exists in both
 * objects the value from the second argument will win.
 *
 * unlike lodash merge, this will not change object references for values that
 * exist only in one parameter.
 *
 * @example merge({thing: 'one'}, {thing: 'two', otherKey: 'one'}, {coolKey: 'coolValue'});
 */
const merge = (...[thing1, ...tail]) => {
    const mergedTail = tail.length > 0
        ? (0, exports.merge)(...tail)
        : null;
    if (!mergedTail) {
        return thing1;
    }
    return {
        ...thing1,
        ...mergedTail,
        ...(0, exports.getCommonProperties)(thing1, mergedTail).reduce((result, property) => ({
            ...result,
            ...((0, guards_1.isPlainObject)(thing1[property]) && (0, guards_1.isPlainObject)(mergedTail[property])
                ? { [property]: (0, exports.merge)(thing1[property], mergedTail[property]) }
                : (Array.isArray(thing1[property]) && Array.isArray(mergedTail[property]))
                    ? { [property]: [...thing1[property], ...mergedTail[property]] }
                    : {}),
        }), {}),
    };
};
exports.merge = merge;
